import React from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from './SelectFilter'

interface RebateApprovalTypeFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const RebateApprovalTypeFilter: React.FC<RebateApprovalTypeFilterProps> = ({
  filter,
  onFilterChange,
}) => {
  const { ibRebatesApprovalTypes } = useAppSelector(({ partnerships }) => partnerships)

  const data = ibRebatesApprovalTypes.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.id,
  }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}
